import { FC, HTMLAttributes } from 'react';
import { Link } from 'react-router-dom';

import { theme } from 'antd';
import cn from 'classnames';

import LogoImage from 'assets/images/logo.svg?react';

import styles from './Logo.module.scss';

interface ILogoProps extends HTMLAttributes<HTMLDivElement> {
	collapsed: boolean;
}

export const Logo: FC<ILogoProps> = ({ className, collapsed, ...props }) => {
	const {
		token: { colorText },
	} = theme.useToken();

	return (
		<div {...props} className={cn(className, styles.logo, { [styles.collapsed]: collapsed })}>
			<Link className={styles.link} to="/" style={{ color: colorText }}>
				<LogoImage />
				{!collapsed && <span className={styles.text}>Affilead</span>}
			</Link>
		</div>
	);
};
